var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-frame d-flex align-center justify-center px-5 cursor-pointer",style:({'height': _vm.height}),on:{"click":_vm.eventClick}},[_c('span',{staticClass:"text-uppercase white--text bold",staticStyle:{"white-space":"nowrap"},style:({ 'font-size': _vm.$vuetify.breakpoint.xs ? '14px':'16px' })},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }